import cls from "classnames";
import { ReactComponent as CircularOutlined } from "./circular.svg";
import { jsx as _jsx } from "react/jsx-runtime";
function Circular(_ref) {
  var bem = _ref.bem;
  return /*#__PURE__*/_jsx("div", {
    className: cls(bem("circular")),
    children: /*#__PURE__*/_jsx(CircularOutlined, {})
  });
}
export default Circular;